import { Choice } from "./Choice";
import { ICartItems } from "../../../Interfaces/Cart";
import { formatMoney } from "../../../Utils/Money";

export class RentalFlow extends Choice {
    constructor(templateId: string, eventContinue: string, cartItems: ICartItems) {
        super("template#cart-flow-header", "template#rental-flow-tabs", templateId, eventContinue);
        this.cartItems = cartItems;
    }

    /**
     * @inheritDoc
     */
    protected initContent(): this {
        super.initContent();
        this.insertPricesPerDay();
        return this;
    }

    /**
     * Prices for some services are charged per day and need to be
     * calculated according to the quantity of a rental product in cart.
     * @private
     */
    private insertPricesPerDay(): void {
        this.content.querySelectorAll<HTMLElement>("[data-price]").forEach((element) => {
            const pricePerDay = parseInt(element.dataset.price);
            // Cart items are stacked
            this.updatePriceNode(element, pricePerDay * this.quantity);
        });
    }

    protected updatePriceNode(element: HTMLElement, price: number) {
        super.updatePriceNode(element, price);
        element.innerHTML = formatMoney(price, this.headerTemplate.dataset.moneyFormat);
    }
}
